import { render, staticRenderFns } from "./stockDetails.vue?vue&type=template&id=1f459818&"
import script from "./stockDetails.vue?vue&type=script&lang=js&"
export * from "./stockDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports